"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var material_1 = require("@angular/material/");
var vc_room_base_1 = require("./vc-room-base");
var VCRoomComponent = /** @class */ (function (_super) {
    __extends(VCRoomComponent, _super);
    function VCRoomComponent(dialog, webRTC, vcService, mediaDevicesService, networkService, vcCmsService) {
        return _super.call(this, vcCmsService, dialog, webRTC, vcService, networkService) || this;
    }
    VCRoomComponent = __decorate([
        core_1.Component({
            selector: 'sis-vc-room',
            template: require('./vc-room.component.html'),
            styles: [require('./vc-room.component.css')]
        }),
        __metadata("design:paramtypes", [material_1.MatDialog,
            services_1.WebRTCService,
            services_1.VcService,
            services_1.MediaDevicesService,
            services_1.NetworkService,
            services_1.IVCCmsService])
    ], VCRoomComponent);
    return VCRoomComponent;
}(vc_room_base_1.VcRoomBase));
exports.VCRoomComponent = VCRoomComponent;
//# sourceMappingURL=vc-room.component.js.map